import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: "padStart" })
export class PadStartPipe implements PipeTransform {
  transform(value: unknown, maxLength: number, fillString: string = " "): string {
    return value?.toString().padStart(maxLength, fillString);
  }
}